export default __webpack_public_path__ + "static/media/Group2131@2x.e4d47254.png";